interface UserError extends Error {
    isUserError: boolean;
}

function throwUserError(message?: string): void {
    const error = new Error(message) as UserError;
    error.isUserError = true;
    throw error;
}

function isUserError(error: any): boolean {
    if (error != null) {
        const userError = error as UserError;
        if (userError.isUserError) {
            return true;
        }
    }

    return false;
}

export { isUserError, throwUserError, UserError };
